import countries from "@gqlapp/config/country/countries";

/**
 *
 * @param value
 * @param options
 * @returns {{area: *, code: *, phoneNumber: string}}
 */
function getPhoneValues(value, options){
	let area = options?.area;

	if(!!value) (value = `${value}`.replace('+', ''));

	let code = '', phoneNumber = '', values = [];

	(value) && (values = value.split(' '));

	if(values.length === 2) ([code, phoneNumber] = values);

	let res = null;
	if(!!code && (!area || typeof area === 'undefined')){
		try{
			res = countries.f(`${code}`, { matchFrom: 'equal', stringify: ({ phone })=>`${phone}`}).shift();
		}catch (e) {}
	}else{
		area = options?.country || 'VN';
		res = countries.f(area, { matchFrom: 'equal', stringify: ({ value })=>`${value}` }).shift();
	}

	if(!!(res)) ({ phone: code, value:area } = res);

	return ({ area, code, phoneNumber })
}

export default getPhoneValues;
